import { VISITOR_PHOTO_SUFFIXES, VISITOR_PHOTO_PREFIX } from 'basic/config'

export const getVisitorPhotoSrc = (src, size) => {
  return src.startsWith(VISITOR_PHOTO_PREFIX)
    ? src.replace(/(\.[a-z0-9]+$)/i, `${VISITOR_PHOTO_SUFFIXES[size]}$1`)
    : src
}
